import React from 'react';
import { withTranslation } from '../../ChildrenContext.js';
import PropTypes from 'prop-types';
import CurrencyRatioPageContainerComponent from './CurrencyRatioPageContainer/CurrencyRatioPageContainer.container';

const CurrencyRatioPage = ({ t }) => {
    const staticNames = t?.currencyPage || {};

    return (
        <React.Fragment>
            <div className="page-heading">
                <div className="page-heading__inner">
                    <h2>{staticNames.title}</h2>
                </div>
            </div>

            <section className="wrapper-content finance">
                <CurrencyRatioPageContainerComponent />
            </section>
        </React.Fragment>
    );
};

CurrencyRatioPage.propTypes = {
    t: PropTypes.object
};

export default withTranslation(CurrencyRatioPage);
